module.exports = __webpack_public_path__ + "static/media/connections-img.f580487f.png";